module.exports = __webpack_public_path__ + "static/Elefun_and_Friends-a99ab6c9e83e5aa47d3fcab027740f09.mp4";